import {connect} from "react-redux"
import {createSelector} from "reselect"
import {IncomingHttpHeaders} from "http"
import {BURGER_MENU_TRANSITION_DURATION, FULL_WIDTH_CONTAINER, REALM_HEADER} from "../../config/constants"
import urls from "../../config/urls"
import State from "../../ducks/state"
import {setPrimaryNavIndex} from "../../ducks/primary-nav"
import {setIsInSecondaryMeganav} from "../../ducks/secondary-nav"
import {FullWidthContainer} from "../../models/secondary-nav"
import {filterByExcludeFrom, filterColumnsByExcludeFrom} from "../../utils/excludeFrom"

import {getPersonalisedSecondaryNavContent} from "../../utils/getPersonalisedSecondaryNavContent"

const cataloguesSelector = (state: State) => state.secondarynav.catalogues
const tabsActivitySelector = (state: State) => state.tabsActivity
const activeDepartmentSelector = (state: State) => state.primarynav.activeDepartment
const showAsWideViewSelector = (_, showAsWideView: boolean) => showAsWideView

const defaultfirstTabIndex = 0

const activeTabSelector = createSelector(
    cataloguesSelector,
    tabsActivitySelector,
    activeDepartmentSelector,
    showAsWideViewSelector,
    (catalogues, tabsActivity, activeDepartment, showAsWideView) => {
        const activeTabIndex = !showAsWideView
            ? defaultfirstTabIndex
            : tabsActivity[activeDepartment] || defaultfirstTabIndex

        const {items: tabs} = (catalogues && catalogues[activeDepartment]) || {
            items: [],
            banner: null,
        }
        const filteredExcludedTabs = tabs.filter(filterByExcludeFrom(showAsWideView))
        const activeTab = filteredExcludedTabs[activeTabIndex]

        return activeTab
    },
)

const columnsSelector = createSelector(activeTabSelector, showAsWideViewSelector, (activeTab, showAsWideView) => {
    const columns = (activeTab && filterColumnsByExcludeFrom(showAsWideView, activeTab.items)) || []

    return columns
})

const missionsSelector = createSelector(activeTabSelector, showAsWideViewSelector, (activeTab, showAsWideView) => {
    const missions =
        activeTab && activeTab.missions
            ? {...activeTab.missions, items: activeTab.missions.items.filter(filterByExcludeFrom(showAsWideView))}
            : null

    return missions
})

const hasMissionsSelector = createSelector(missionsSelector, showAsWideViewSelector, (missions, showAsWideView) => {
    return (missions && Object.keys(missions).length > 0 && filterByExcludeFrom(showAsWideView)(missions)) ?? false
})

const personalisationEnabledSelector = (state: State) => state.settings.personalisationEnabled

const personalisationContentSelector = createSelector(
    activeTabSelector,
    showAsWideViewSelector,
    personalisationEnabledSelector,
    (activeTab, personalisationEnabled) => {
        return personalisationEnabled && activeTab && activeTab[FULL_WIDTH_CONTAINER]
            ? getPersonalisedSecondaryNavContent(activeTab[FULL_WIDTH_CONTAINER] as FullWidthContainer)
            : null
    },
)

export const mapStateToProps = (state: State, {showAsWideView}: {showAsWideView: boolean}) => {
    const {
        primarynav: {activeDepartment},
        secondarynav: {isInSecondaryNav},
        request: {siteUrl},
        settings: {variant, iconsVersionPath},
    } = state

    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string

    const chevronIcon = urls.burgerMenu.chevronUrl(realm, variant, iconsVersionPath)
    const showSecondaryNav = activeDepartment !== ""

    const missions = missionsSelector(state, showAsWideView)

    const englishDepartment = state.secondarynav.catalogues[activeDepartment]?.englishTitle || ""

    return {
        columns: columnsSelector(state, showAsWideView),
        department: activeDepartment,
        englishDepartment,
        isInSecondaryNav,
        chevronIcon,
        text: state.text.missionsCTA,
        showSecondaryNav,
        missions,
        hasMissions: hasMissionsSelector(state, showAsWideView),
        personalisationContent: personalisationContentSelector(state, showAsWideView),
        siteUrl,
        templating: state.template,
        textAlignment: state.textAlignment,
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        deactivateIndex: () => {
            dispatch(setIsInSecondaryMeganav(false))
            setTimeout(() => {
                dispatch(setPrimaryNavIndex(-1, ""))
            }, BURGER_MENU_TRANSITION_DURATION)
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
